
<div id="seek-button-container">
  <div id="seek-button" [style.left]="(dragging? seekDragPosition * 100 : displaySeekPosition * 100)+'%'"
    (mousedown)="seekMouseDown($event)">
    <div id="seek-button-visual">
      <span *ngIf="dragging" id="time-span">{{ seekPreviewValue | duration: 'short-seconds'}}</span>
    </div>
  </div>  
</div> 
<div #seekTrackReceiver id="seek-receiver" 
  (mousedown)="seekMouseDown($event)"></div>
<div id="seek-bar"></div>